@if (!tab.showLoader) {
    <div menuSystem [cerrixTab]="tab" class="details">
        <div
            class="screens"
            [attr.name]="'detail.menuAsset' | t"
            menuicon="fas fa-cube"
            menusystemsubmenu
        >
            <div
                [attr.name]="'detail.menuDetails' | t"
                menuItemId="details"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <app-cerrix-header
                    data-uiid="asset-register-name"
                    [(title)]="model.name"
                    [edit]="true"
                    [requiredMessage]="'detail.nameRequired' | t"
                    [titlePlaceholder]="
                        (model.reference === undefined
                            ? 'detail.newAssetNamePlaceholder'
                            : 'detail.assetNamePlaceholder'
                        ) | t
                    "
                    [breadcrumbs]="breadcrumbs"
                ></app-cerrix-header>
                <div class="body">
                    <div class="input-fields-block">
                        <div class="input-row">
                            <app-cerrix-user-select
                                name="asset-owner"
                                data-uiid="asset-register-owner"
                                [types]="ownerTypes"
                                [value]="ownerValue"
                                [label]="'register.assignedLabel' | t"
                                [infoText]="
                                    'edit-ownership-information.ownerInfo'
                                        | t
                                "
                                [dialogTitle]="
                                    'edit-ownership-information.ownerDialogTitle'
                                        | t
                                "
                                [confirmText]="
                                    'edit-ownership-information.ownerDialogConfirmText'
                                        | t
                                "
                                [emptyText]="
                                    'edit-ownership-information.ownerSelectorEmptyText'
                                        | t
                                "
                                (valueChange)="onOwnerIdChange($event['owner']?.[0])"
                            ></app-cerrix-user-select>
                            <app-cerrix-datepicker-group
                                data-uiid="asset-register-date-in-use"
                                format="dd-MM-yyyy"
                                [placeholder]="
                                    'register.dateInUsePlaceholder' | t
                                "
                                [(value)]="model.lifecycle.dateInUse"
                                >{{
                                    "detail.dateInUseLabel" | t
                                }}</app-cerrix-datepicker-group
                            >
                            <app-cerrix-datepicker-group
                                data-uiid="asset-register-date-out-of-use"
                                format="dd-MM-yyyy"
                                [placeholder]="
                                    'register.dateOutOfUsePlaceholder' | t
                                "
                                [mustBeAfter]="model.lifecycle.dateInUse"
                                [afterErrorMessage]="
                                    'edit-lifecycle-information.dateOutOfUseErrorMessage'
                                        | t
                                "
                                [(value)]="model.lifecycle.dateOutOfUse"
                                >{{
                                    "detail.dateOutOfUseLabel" | t
                                }}</app-cerrix-datepicker-group
                            >
                        </div>
                        <div class="input-row">
                            <cerrix-textarea-group
                                [attr.data-uiid]="'asset-description'"
                                [name]="'asset-description'"
                                [textareaDialogTitle]="
                                    'register.descriptionTitle' | t
                                "
                                [infoText]="
                                    'register.descriptionInfoText' | t
                                "
                                [rows]="5"
                                placeholder="Enter a description"
                                [value]="model.description"
                                (valueChange)="model.description = $event"
                                >{{
                                    "register.descriptionTitle" | t
                                }}</cerrix-textarea-group
                            >
                        </div>
                        <div class="input-row">
                            <app-cerrix-tree-item-picker-single
                                name="organization-owner"
                                data-uiid="asset-register-organization"
                                appValidationRequired
                                [items]="organizationOwnerList"
                                [selectedValue]="model.ownershipInformation.owningOrganizationId"
                                [label]="
                                    'detail.organizationOwnerLabel' | t
                                "
                                [placeholder]="
                                    'edit-ownership-information.organizationPlaceholder'
                                        | t
                                "
                                [dialogTitle]="
                                    'edit-ownership-information.organizationDialogTitle'
                                        | t
                                "
                                [infoText]="
                                    'edit-ownership-information.organizationOwnerInfo'
                                        | t
                                "
                                (valueChanged)="
                                    model.ownershipInformation.owningOrganizationId = $event
                                "
                                iconPrefix="third-party"
                                defaultIcon="third-party"
                                >{{
                                    "detail.organizationOwnerLabel" | t
                                }}</app-cerrix-tree-item-picker-single
                            >
                        </div>
                    </div>
                </div>
                <cerrix-page-footer>
                    <div class="asset-management-footer">
                        <div class="left-button-group">
                            <cerrix-button
                                buttonType="secondary"
                                buttonSize="big"
                                secondaryColor="outlined-gray"
                                data-uiid="asset-management-cancel-asset"
                                (click)="cancel()"
                            >
                                {{ "detail.cancelButton" | t }}
                            </cerrix-button>
                            <cerrix-button
                                buttonType="secondary"
                                buttonSize="big"
                                data-uiid="asset-management-save-asset"
                                icon="check"
                                iconPosition="right"
                                [text]="'detail.registerSaveButton' | t"
                                [resultText]="'detail.savedButton' | t"
                                (click)="save()"
                                [disabled]="validationErrors() || !saveButtonEnabled"
                            >
                            </cerrix-button>
                        </div>
                    </div>
                </cerrix-page-footer>
            </div>
        </div>
    </div>
}
